import { Link } from 'react-router-dom';
import LegalPage, { Section } from './LegalPage';

export default function AboutPage() {
  return (
    <LegalPage
      title="About My Bets"
      intro="My Bets is an AI-assisted sports betting platform built for South Africa. We combine live odds with AI-powered insights — for entertainment. Bet responsibly."
    >
      <Section heading="Who we are">
        <p>
          My Bets is operated by Marome Investments (Pty) Ltd. We offer betting on football, rugby,
          cricket, tennis and more, with AI insights that help you understand the markets. Those
          insights are for information only and never guarantee an outcome.
        </p>
      </Section>

      <Section heading="Licensing">
        <p>
          My Bets is operated by Marome Investments (Pty) Ltd. Licensed bookmaker — licence details
          pending. Our full licence number and regulator details will be published here once issued.
        </p>
      </Section>

      <Section heading="Our commitment to safe betting">
        <p>
          Betting is for adults 18 and older and should always be fun. We verify identity and age at
          registration, provide deposit limits, time-outs and self-exclusion, and support the national
          Responsible Gambling helpline on{' '}
          <a href="tel:0800006008" className="font-semibold text-primary hover:underline">
            0800 006 008
          </a>
          . See our{' '}
          <Link to="/responsible-gambling" className="font-semibold text-primary hover:underline">
            Responsible Gambling
          </Link>{' '}
          page.
        </p>
      </Section>

      <Section heading="Contact">
        <p>
          Email:{' '}
          <a
            href="mailto:support@sports-betting.my-investments.io"
            className="font-semibold text-primary hover:underline"
          >
            support@sports-betting.my-investments.io
          </a>
          . To raise a dispute, see our{' '}
          <Link to="/complaints" className="font-semibold text-primary hover:underline">
            Complaints
          </Link>{' '}
          page.
        </p>
      </Section>
    </LegalPage>
  );
}
